<nz-form-control *ngIf="!isWizard"
	[nzErrorTip]="errorMessage | translate:translationData" [nzWarningTip]="errorMessage | translate:translationData" [nzValidateStatus]="validateStatus"
	[ngClass]="{'large-form': isWizard}" class="text-input"
>
	<nz-row [nzJustify]="justify">
		<nz-input-group class="input-group" [nzAddOnAfter]="question.unit">
			<div class="d-inline-block width-100p" style="position: relative">
				<input
						class="input-field-number"
						nz-col
						type="text"
						[(ngModel)]="selected_display"
						(ngModelChange)="changeSelectedDisplay()"
						[disabled]="finishedAndLocked || isLocked"
						(focusout)="exitFocus()"
						[required]="!this.question.isAnswerOptional"
						[step]="steps"
						(keyup)="changeSelectedOnKeypress($event)"
				/>
				<div class="input-ticker">
					<button [disabled]="finishedAndLocked || isLocked" tabIndex="-1" nz-button class="ticker tick-up" (click)="changeSelected(1)">
						<i nz-icon nzType="up" nzTheme="outline" class="tick-icon"></i>
					</button>
					<button [disabled]="finishedAndLocked || isLocked" tabIndex="-1" nz-button class="ticker tick-down" (click)="changeSelected(-1)">
						<i nz-icon nzType="down" nzTheme="outline" class="tick-icon"></i>
					</button>
				</div>
			</div>
		</nz-input-group>
	</nz-row>
</nz-form-control>

<nz-row *ngIf="isWizard" [nzJustify]="justify" class="block-margin">
	<nz-slider nzVertical
						[nzMin]="question.rangeLow"
						[nzMax]="question.rangeHigh"
						[(ngModel)]="selected" class="big-slider"
						[nzMarks]="marks"
						[nzStep]="steps"
						(nzOnAfterChange)="changeImmediately()"
						[disabled]="finishedAndLocked || isLocked"
						nzTooltipVisible="never"
	></nz-slider>
	<div class="ml-3 centered">
		<div class="centered">
			<button nz-button nzType="primary" nzShape="circle" nzSize="large"
							(click)="changeSelected(1)"
							(focusout)="exitFocus()"
							[disabled]="finishedAndLocked || isLocked"
							class="wiz-plus-btn"
			>
				<i nz-icon nzType="plus"></i>
			</button>
		</div>
		<div>
			<label *ngIf="selected || selected === 0" class="big-label">
				{{ selected | number: '1.0-3': language }} {{ question.unit }}
			</label>
			<label *ngIf="!selected && selected !== 0" class="big-label">&nbsp;</label>
		</div>
		<div class="centered">
			<button nz-button nzType="primary" nzShape="circle" nzSize="large"
							(click)="changeSelected(-1)"
							(focusout)="exitFocus()"
							[disabled]="finishedAndLocked || isLocked"
							class="wiz-minus-btn"
			>
				<i nz-icon nzType="minus"></i>
			</button>
		</div>
	</div>
</nz-row>
